import axios from '@/api/axios'


const getReturnProducts = (data) => {
    return axios
        .post('/admin/return/return-products', {return: data})
        .then(response => response.data)
}

const getReturnPayments = (data) => {
    return axios
        .post('/admin/return/return-payments', {return: data})
        .then(response => response.data)
}

const createReturn = (data) => {
    return axios
        .post('/admin/return/create-return', {return: data})
        .then(response => response.data)
}

const returnReceipt = (data) => {
    return axios
        .post('/admin/return/return-receipt', {return: data})
        .then(response => response.data)
}

const makeReturn = (data) => {
    return axios
        .post('/admin/return/make-return', {return: data})
        .then(response => response.data)
}

const makeCancel = (data) => {
    return axios
        .post('/admin/return/make-cancel', {return: data})
        .then(response => response.data)
}

export default {
    getReturnProducts,
    getReturnPayments,
    createReturn,
    makeReturn,
    makeCancel,
    returnReceipt
}